import React from 'react';
import './Modal.css';

const Modal = ({ isOpen, onClose, title, children, size = 'md', position = 'center' }) => {
  if (!isOpen) return null;

  return (
    <div
      className={`app-modal-overlay ${position === 'right' ? 'app-modal-overlay-right' : ''}`}
      onClick={onClose}
      role="presentation"
    >
      <div
        className={`app-modal-container app-modal-${size} ${position === 'right' ? 'app-modal-right' : ''}`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <div className="app-modal-header">
          <h3>{title}</h3>
          <button type="button" className="app-modal-close" onClick={onClose} aria-label="Close">
            &times;
          </button>
        </div>
        <div className="app-modal-body">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
